import { render, staticRenderFns } from "./goods-in-review.vue?vue&type=template&id=55b7ad76"
import script from "./goods-in-review.vue?vue&type=script&lang=js"
export * from "./goods-in-review.vue?vue&type=script&lang=js"
import style0 from "./goods-in-review.vue?vue&type=style&index=0&id=55b7ad76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports